import { components } from '../api-abcscale';
import { apiGet, apiPost, apiPut, apiDelete, apiPostDownload, ApiCallbacks } from '../apiClient';

type SkuDto = components['schemas']['SkuDto'];
type SkuDiscountDto = components['schemas']['SkuDiscountDto'];
type SkuPartsDiscountDto = components['schemas']['SkuPartsDiscountDto'];
type PriceQuoteRowDto = components['schemas']['PriceQuoteRowDto'];

const ADMIN_API_BASE = process.env.REACT_APP_ADMIN_API_BASE;

export async function searchSkuByPartNumber(
  partNumber: string,
  callbacks: ApiCallbacks<SkuDto[]>
): Promise<void> {
  await apiGet(
    `${ADMIN_API_BASE}/Sku/${encodeURIComponent(partNumber)}`,
    callbacks,
    true
  );
}

export async function getSkuDiscounts(
  callbacks: ApiCallbacks<SkuDiscountDto[]>
): Promise<void> {
  await apiGet(
    `${ADMIN_API_BASE}/skudiscounts`,
    callbacks,
    true
  );
}

export async function updateSku(
  skuId: number,
  dto: SkuDto,
  callbacks: ApiCallbacks<void>
): Promise<void> {
  await apiPut(
    `${ADMIN_API_BASE}/Sku/${skuId}`,
    dto,
    callbacks,
    true
  );
}

export async function reviewSku(
  skuId: number,
  reviewedBy: string,
  callbacks: ApiCallbacks<void>
): Promise<void> {
  await apiPut(
    `${ADMIN_API_BASE}/Sku/${skuId}/validate`,
    { reviewedBy },
    callbacks,
    true
  );
}

export async function createSku(
  dto: SkuDto,
  callbacks: ApiCallbacks<SkuDto>
): Promise<void> {
  await apiPost(
    `${ADMIN_API_BASE}/Sku`,
    dto,
    callbacks,
    true
  );
}

export async function createSkuDiscount(
  dto: SkuDiscountDto,
  callbacks: ApiCallbacks<SkuDiscountDto>
): Promise<void> {
  await apiPost(
    `${ADMIN_API_BASE}/skudiscounts`,
    dto,
    callbacks,
    true
  );
}

export async function updateSkuDiscount(
  discountId: string,
  dto: SkuDiscountDto,
  callbacks: ApiCallbacks<void>
): Promise<void> {
  await apiPut(
    `${ADMIN_API_BASE}/skudiscounts/${encodeURIComponent(discountId)}`,
    dto,
    callbacks,
    true
  );
}

export async function deleteSkuDiscount(
  discountId: string,
  callbacks: ApiCallbacks<void>
): Promise<void> {
  await apiDelete(
    `${ADMIN_API_BASE}/skudiscounts/${encodeURIComponent(discountId)}`,
    callbacks,
    true
  );
}

export async function createSkuPartsDiscount(
  dto: SkuPartsDiscountDto,
  callbacks: ApiCallbacks<SkuPartsDiscountDto>
): Promise<void> {
  await apiPost(
    `${ADMIN_API_BASE}/skupartsdiscounts`,
    dto,
    callbacks,
    true
  );
}

export async function getSkuPartDiscountsByIdentifier(
  identifier: string,
  callbacks: ApiCallbacks<SkuDiscountDto[]>
): Promise<void> {
  await apiGet(
    `${ADMIN_API_BASE}/skupartsdiscounts/product/${encodeURIComponent(identifier)}`,
    callbacks,
    true
  );
}

export async function getSkuPartsDiscountsByProductId(
  productId: number,
  callbacks: ApiCallbacks<SkuPartsDiscountDto[]>
): Promise<void> {
  await apiGet(
    `${ADMIN_API_BASE}/skupartsdiscounts?productId=${productId}`,
    callbacks,
    true
  );
}

export async function deleteSkuPartsDiscount(
  id: number,
  callbacks: ApiCallbacks<void>
): Promise<void> {
  await apiDelete(
    `${ADMIN_API_BASE}/skupartsdiscounts/${id}`,
    callbacks,
    true
  );
}

export async function exportQuote(
  rows: PriceQuoteRowDto[],
  onError: (message: string) => void
): Promise<void> {
  await apiPostDownload(
    `${ADMIN_API_BASE}/Sku/export-quote`,
    rows,
    'cotizacion.xlsx',
    onError,
    true
  );
}
